export enum TestID {
  GenerateButton = 'pin-panel-generate-btn',
  CopyButton = 'pin-panel-copy-btn',
  CustomPinButton = 'pin-panel-custom-pin-btn',
  ErrorMessage = 'pin-panel-error-message',
  CustomPinErrorMessage = 'pin-panel-custom-pin-error-message',
  CustomPinWrongLengthError = 'pin-panel-custom-pin-wrong-length-error',
  CustomPinUnsecureError = 'pin-panel-custom-pin-unsecure-error',
  CustomPinAlreadyExistsError = 'pin-panel-custom-pin-already-exists-error',
  CustomPinHelperMessage = 'pin-panel-custom-pin-helper-message',
}

// Keys are the yup test names from UserPinModalNew/validationSchema.
const customPinErrorTestIds: Record<string, TestID> = {
  'check-length': TestID.CustomPinWrongLengthError,
  'is-unique-pin': TestID.CustomPinAlreadyExistsError,
  'no-silly-pin': TestID.CustomPinUnsecureError,
};

export const getCustomPinErrorTestId = (errorType?: string) =>
  (errorType && customPinErrorTestIds[errorType]) || TestID.CustomPinErrorMessage;
